/*
  Promo Carousel
  --------------
  Section script for sections/promo-carousel.liquid.
*/

window.theme = window.theme || {};

theme.PromoCarousel = (function() {
  function avoidReflow(el) {
    if (!el.id) {
      return;
    }
    var firstChild = el.firstElementChild;
    if (!firstChild) {
      return;
    }
    var style = document.createElement('style');
    style.innerHTML = '#' + el.id + ' .flickity-viewport{height:' + firstChild.offsetHeight + 'px}';
    document.head.appendChild(style);
  }

  function getReferenceImageHeight(slider) {
    var firstSlide = slider.querySelector('.promo-carousel__slide');
    if (!firstSlide) {
      return 0;
    }
    var wraps = firstSlide.querySelectorAll('.promo-carousel__image-wrap');
    for (var i = 0; i < wraps.length; i++) {
      if (wraps[i].offsetHeight > 0) {
        return wraps[i].offsetHeight;
      }
    }
    return 0;
  }

  function PromoCarousel(container) {
    this.container = container;
    this.slider = container.querySelector('[data-promo-carousel]');

    if (!this.slider) {
      return;
    }

    theme.loadImageSection(this.slider);

    var slideCount = this.slider.querySelectorAll('.promo-carousel__slide').length;

    if (slideCount <= 1) {
      return;
    }

    var autoPlay = this.slider.dataset.autoplay === 'true'
      ? parseInt(this.slider.dataset.speed)
      : false;

    requestAnimationFrame(function() {
      avoidReflow(this.slider);

      this.flickity = new Flickity(this.slider, {
        cellSelector: '.promo-carousel__slide',
        cellAlign: 'left',
        groupCells: false,
        wrapAround: true,
        contain: true,
        adaptiveHeight: false,
        pageDots: this.slider.dataset.dots === 'true',
        prevNextButtons: this.slider.dataset.arrows === 'true',
        autoPlay: autoPlay,
        pauseAutoPlayOnHover: false,
        rightToLeft: (window.theme && theme.config && theme.config.rtl) || false
      });

      this._updateArrowPosition();

      this._resizeHandler = theme.utils.debounce(250, function() {
        if (this.flickity && typeof this.flickity.resize === 'function') {
          this.flickity.resize();
        }
        this._updateArrowPosition();
      }.bind(this));

      window.addEventListener('resize', this._resizeHandler);

      window.dispatchEvent(new Event('resize'));
    }.bind(this));
  }

  PromoCarousel.prototype = Object.assign({}, PromoCarousel.prototype, {
    _updateArrowPosition: function() {
      var height = getReferenceImageHeight(this.slider);
      if (height > 0) {
        this.slider.style.setProperty('--carousel-image-height', height + 'px');
      }
    },

    onUnload: function() {
      window.removeEventListener('resize', this._resizeHandler);
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }
    },

    onDeselect: function() {
      if (this.flickity && this.flickity.options.autoPlay && typeof this.flickity.playPlayer === 'function') {
        this.flickity.playPlayer();
      }
    },

    onBlockSelect: function(evt) {
      if (!this.flickity) {
        return;
      }

      var slide = this.container.querySelector('.promo-carousel__slide--' + evt.detail.blockId);
      if (!slide) {
        return;
      }
      var index = parseInt(slide.dataset.index);

      if (typeof this.flickity.select === 'function') {
        this.flickity.select(index);
      }
      if (typeof this.flickity.pausePlayer === 'function') {
        this.flickity.pausePlayer();
      }
    },

    onBlockDeselect: function() {
      if (this.flickity && this.flickity.options.autoPlay && typeof this.flickity.playPlayer === 'function') {
        this.flickity.playPlayer();
      }
    }
  });

  return PromoCarousel;
})();

(function() {
  function registerPromoCarousel() {
    if (window.theme && theme.sections && !theme.sections.constructors['promo-carousel']) {
      theme.sections.register('promo-carousel', theme.PromoCarousel);
    }
  }

  if (window.theme && theme.sections) {
    registerPromoCarousel();
  } else {
    document.addEventListener('page:loaded', registerPromoCarousel);
  }
})();